import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const FormCheckbox = (props) => {
    const { checked, handleChange, name, label, disabled } = props;

    return (
        <Fragment>
            <label className="label-inline-checkbox">
                <input type="checkbox" name={name} checked={checked} onChange={handleChange} disabled={disabled} />
                {label}
            </label>
        </Fragment>
    );
};

export default FormCheckbox;
